export default __webpack_public_path__ + "static/media/scrabble-1440w.4a45c3ec.avif";